import React, { useState, useRef, useEffect } from "react";
import styled from "styled-components";
import cx from "classnames";
import { PromoCard } from "components/components/molecules";
import CloseIcon from "components/icons/Close";
import useBreakpoint from "utils/hooks/useBreakpoint";
import Carousel from "@brainhubeu/react-carousel";
import { useCountryValue } from "stores/country";
import { StyledModal } from "components/shared";
import { Copy } from "components/components/atoms";
import { IconButton } from "components/components/atoms";
import useNewColorSchemaOptions from "utils/hooks/useNewColorSchemaOptions";
import useOnClickOutside from "utils/hooks/useOnClickOutside";

const MAX_PROMO_CARDS = 5;

const PromoPanelContainer = styled.div``;

const CarouselContainer = styled.div`
  pointer-events: all;
  & ul,
  & .BrainhubCarousel,
  & .BrainhubCarousel__trackContainer {
    overflow: visible !important;
  }

  ${({ paddingLeft }) => paddingLeft && `padding-left: ${paddingLeft}px;`}
`;

const StickyButton = styled.div`
  pointer-events: all;
  letter-spacing: 0.036em;
`;

const ModalContent = styled.div`
  ${({ isMobile }) =>
    isMobile
      ? `
        width: 91.5vw;
        height: 90vh;
        margin: auto;
      `
      : `
        width: 80vw;
        height: 80vh;
        margin: auto;
        max-width: 69.625rem;
      `}
`;

const PromosPanel = ({ title, cards, blueBackground }) => {
  const ItemCLoseClickRef = useRef();
  const firstCardItem = useRef([]);
  const modalRef = useRef();
  const {
    showNewSchemaColor,
    newSchemaColorHexaCode,
    newSchemaTextColorHexaCode,
  } = useNewColorSchemaOptions();
  const getSlides = (cards, country, findSize) => {
    const filteredCards = cards.filter((c) => c.country === country);
    const filterCardsLenght = filteredCards.slice(0, MAX_PROMO_CARDS);

    return filteredCards.slice(0, MAX_PROMO_CARDS).map((c, i) => (
      <div
        // onBlur={(e) => {
        //   e.preventDefault();
        //   if (i + 1 == filterCardsLenght.length) {
        //     setTimeout(() => {
        //       ItemCLoseClickRef.current.focus();
        //     }, 1);
        //   }
        // }}
        onKeyDown={(e) => {
          if (e.shiftKey && e.key === "Tab" && i == 0) {
            // setFlyoutOpen(false);
            ItemCLoseClickRef.current.tabIndex = 0;
          }
        }}
        key={c.id}
        className="md:pb-4 md:pt-4 w-full pt-2 pb-4"
      >
        <PromoCard
          ref={(e) => {
            firstCardItem.current[i] = e;
          }}
          cardIndex={i}
          filterCardsLenght={filterCardsLenght}
          ItemCLoseClickRef={ItemCLoseClickRef}
          style={findSize ? { scale: ".60" } : { scale: "1" }}
          data-aos="fade-left"
          data-aos-delay={i * 150}
          promoCard={c}
          key={c.id}
          handleShowModal={(text) => {
            setPromoDisclaimerText(text);
            setShowModalDisclaimer(true);
            if (modalRef) {
              setTimeout(() => {
                handleFocus(i);
              }, 100);
            }
          }}
          showNewSchemaColor={showNewSchemaColor}
          newSchemaColorHexaCode={newSchemaColorHexaCode}
          newSchemaTextColorHexaCode={newSchemaTextColorHexaCode}
        />
      </div>
    ));
  };
  const breakpoint = useBreakpoint(
    typeof window !== "undefined" && window.innerWidth
  );
  const [{ country }] = useCountryValue();

  const [flyoutOpen, setFlyoutOpen] = useState(false);
  const [slides, setSlides] = useState(getSlides(cards, country));
  const [position, setPosition] = useState(0);
  const [withAnchorCTA, setWithAnchorCTA] = useState(false);
  const [isMetroSearch, setMetroSearch] = useState(false);
  const [showModalDisclaimer, setShowModalDisclaimer] = useState(false);
  const [promoDisclaimerText, setPromoDisclaimerText] = useState();
  const [activePromo, SetActivePromo] = useState();

  const deviceWidth = typeof window !== "undefined" && window.innerWidth;

  const isMobile = ["sm", "xs"].includes(breakpoint);
  const isTablet = ["md"].includes(breakpoint);
  const isDesktop = ["lg"].includes(breakpoint);
  const maxPositionToShow = isTablet ? 3 : isDesktop ? 2 : 0;

  useEffect(() => {
    const anchorCTA = document.getElementById("anchor-cta");
    const metroSearch = document.getElementById("MetroSearch");

    if (anchorCTA) {
      setWithAnchorCTA(true);
    }
    if (metroSearch) {
      setMetroSearch(true);
    }
  }, []);

  let filteredCards = cards.filter((c) => c.country === country);

  //Detect Browser FontsSize Changes
  useEffect(() => {
    if (!ItemCLoseClickRef.current) return;
    const elementClosePromo = ItemCLoseClickRef.current;
    const observer = new ResizeObserver((entries) => {
      for (let entry of entries) {
        if (entry.contentRect.width > 228) {
          const newSlides = getSlides(cards, country, true);
          setSlides(newSlides);
          setPosition(0);
          SetfontSizeLevel(true);
        } else {
          const newSlides = getSlides(cards, country, false);
          setSlides(newSlides);
          setPosition(0);
          SetfontSizeLevel(false);
        }
      }
    });
    if (elementClosePromo) {
      observer.observe(elementClosePromo);
    }
    return () => {
      observer.disconnect();
    };
  }, [cards, fontSizeLevel]);

  //Detect Browser ZoomSize Changes
  useEffect(() => {
    const newZoomLevel = Math.round(window.devicePixelRatio) * 100;
    setZoomLevel(newZoomLevel);
    const handleResize = () => {
      const newZoomLevel = Math.round(window.devicePixelRatio) * 100;
      setZoomLevel(newZoomLevel);
      if (newZoomLevel >= 400) {
        setFlyoutOpen(false);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [zoomLevel]);

  const handleDrag = (value) => {
    setPosition(value);
  };
  const handlePrev = () => {
    setPosition(position - 1);
  };
  const len = filteredCards.length;
  const handleNext = () => {
    if (position < len - 1) {
      setPosition(position + 1);
    }
  };

  const handleFocus = (index) => {
    if (!showModalDisclaimer && modalRef) {
      modalRef.current.focus();
      SetActivePromo(index);
    } else {
      firstCardItem.current[activePromo].tabIndex = 0;
      firstCardItem.current[activePromo].focus();
      firstCardItem.current[activePromo].tabIndex = -1;
    }
  };

  const [zoomLevel, setZoomLevel] = useState(100);

  const [fontSizeLevel, SetfontSizeLevel] = useState();
  const mobileCardWidth = deviceWidth && Math.round(deviceWidth * 0.637);
  const paddingLeft =
    filteredCards.length > 1
      ? fontSizeLevel || zoomLevel == 300
        ? (deviceWidth - 570 * filteredCards.length) / 2
        : (deviceWidth - 470 * filteredCards.length) / 2
      : 0;

  /*useEffect(() => {
    if (typeof window !== "undefined" && document) {
      const body = document.querySelector("body");
      if (body) {
        if (flyoutOpen) {
          body.classList.add("overflow-hidden");
          if (body.style.overflowY) body.style.overflowY = "hidden";
        } else {
          body.classList.remove("overflow-hidden");
          if (body.style.overflowY) body.style.overflowY = "auto";
        }
      }
    }
  }, [flyoutOpen]);*/
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const flyoutButtontRefCurrent = ItemCLoseClickRef.current;
    const observer = new ResizeObserver((entries) => {
      for (let entry of entries) {
        if (entry.contentRect.width > 220) {
          SetfontSizeLevel(true);
        } else {
          SetfontSizeLevel(false);
        }
      }
    });
    if (flyoutButtontRefCurrent) {
      observer.observe(flyoutButtontRefCurrent);
    }
    return () => {
      observer.disconnect();
    };
  }, []);

  useEffect(() => {
    const newZoomLevel = Math.round(window.devicePixelRatio) * 100;
    setZoomLevel(newZoomLevel);

    const handleResize = () => {
      const newZoomLevel = Math.round(window.devicePixelRatio) * 100;
      setZoomLevel(newZoomLevel);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (zoomLevel >= 400) {
      setFlyoutOpen(false);
    } else {
      setIsVisible(true);
    }
  }, [zoomLevel]);

  const promoPanelRef = useRef();
  useOnClickOutside(promoPanelRef, () => {
    setFlyoutOpen(false);
  });

  const [isEndOfCarousel, setIsEndOfCarousel] = useState(false);

  useEffect(() => {
    const element = ItemCLoseClickRef.current;
    if (isEndOfCarousel && element) {
      element.focus();
    }
  }, [isEndOfCarousel]);

  if (filteredCards.length < 1) return null;

  return (
    <>
      {isVisible && (
        <PromoPanelContainer
          style={{
            top: fontSizeLevel ? "0" : false,
          }}
          className={cx(
            "w-full md:w-screen md:h-screen flex flex-col items-center justify-end px-0",
            "bottom-0 z-40 fixed pointer-events-none select-none "
          )}
          isFlyoutOpen={flyoutOpen}
        >
          <StickyButton
            className={cx(
              "md:h-12 relative rounded-t-lg flex items-center leading-4 md:leading-normal",
              "overflow-hidden  cursor-pointer text-center justify-center z-50",
              {
                "py-4 md:py-0 md:pt-1 px-4 md:px-24": !flyoutOpen,
                "pt-3 md:pt-1 pb-2 md:pb-0": flyoutOpen,
                "mb-16 md:mb-0": !flyoutOpen && withAnchorCTA,
                "mb-4": isMetroSearch,
              },
              {
                "h-4": zoomLevel >= 500 || fontSizeLevel,
                "mb-6": zoomLevel >= 500 && flyoutOpen,
                "mb-12": zoomLevel === 300 && flyoutOpen,
              },
              {
                "h-2": zoomLevel >= 600 || fontSizeLevel,
                "scale-75": zoomLevel >= 600 && flyoutOpen,
              },
              {
                "bg-aqua": !showNewSchemaColor,
                "bg-black": showNewSchemaColor,
              }
            )}
            isFlyoutOpen={flyoutOpen}
            withAnchorCTA={withAnchorCTA}
          >
            <button
              ref={ItemCLoseClickRef}
              className={cx(
                "flex uppercase font-trade-gothic-20 font-bold items-center",
                {
                  "ml-6 pr-3": flyoutOpen,
                  "text-promo-dark-blue": !showNewSchemaColor,
                  "text-white": showNewSchemaColor,
                }
              )}
              tabIndex={flyoutOpen ? -1 : 0}
              id="FlyoutButton"
              onClick={() => {
                setFlyoutOpen((pr) => !pr);
                if (!flyoutOpen && firstCardItem) {
                  setTimeout(() => {
                    firstCardItem.current[0].tabIndex = 0;
                    firstCardItem.current[0].focus();
                  }, 100);
                }
              }}
              onFocus={(e) => {
                setIsEndOfCarousel(false);
              }}
              aria-label={title} // flyoutOpen ? `Promotions` : `Promotions`
              aria-expanded={flyoutOpen}
              onBlur={() => {
                if (flyoutOpen && firstCardItem) {
                  firstCardItem.current[0].focus();
                }
              }}
            >
              <span className="text-lg"> {flyoutOpen ? title : title}</span>
              <svg
                className={cx("w-6 h-6 transform mb-1", {
                  "-rotate-90": flyoutOpen,
                  "rotate-90": !flyoutOpen,
                })}
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  fill="currentColor"
                  d="M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
                />
              </svg>
            </button>
            {zoomLevel >= 400 && !flyoutOpen && (
              <svg
                className="text-promo-dark-blue w-6 h-6"
                tabIndex={0}
                role="button"
                onClick={(event) => {
                  event.stopPropagation();
                  setIsVisible(false);
                }}
                aria-label="Hide View Promotion Area"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            )}
          </StickyButton>

          {flyoutOpen && (
            <CarouselContainer
              className={cx(
                " relative w-full z-40 ",
                {
                  "mb-16 md:-mb-0":
                    flyoutOpen && withAnchorCTA && zoomLevel <= 500,
                  "bg-light-blue": blueBackground,
                  "bg-white": !blueBackground,
                },
                {
                  "-mb-6": zoomLevel >= 500,
                  "-mt-12": zoomLevel >= 500,
                },
                {
                  "-mb-0": zoomLevel === 300,
                  "-mt-12": zoomLevel === 300,
                },

                {
                  "-mb-6": fontSizeLevel,
                  "-mt-14": fontSizeLevel,
                },
                {
                  "-mb-12": zoomLevel >= 600,
                  "-mt-22": zoomLevel >= 600,
                }
              )}
              paddingLeft={paddingLeft > 0 ? paddingLeft : 0}
              id="FlyoutCardContainer"
              ref={promoPanelRef}
            >
              {filteredCards && filteredCards.length > 1 && (
                <Carousel
                  value={position}
                  draggable={true}
                  slides={slides}
                  slidesPerScroll={4}
                  onChange={handleDrag}
                  minDraggableOffset={1}
                  itemWidth={
                    isMobile ? mobileCardWidth : fontSizeLevel ? 900 : 470
                  }
                  centered={
                    isMobile || filteredCards.length < 2 || zoomLevel >= 400
                  }
                />
              )}
              {filteredCards && filteredCards.length === 1 && slides}

              {!isMobile && filteredCards.length > 1 && position >= 1 && (
                <IconButton
                  onClick={handlePrev}
                  className="absolute left-0 bottom-0 top-0 m-auto z-20 transition-opacity duration-200
            flex ml-5 sm:w-10 sm:h-10 md:w-16 md:h-16 md:ml-10"
                  icon="arrow-left"
                  idIcon={"ImageCarousel"}
                  color="white"
                  small={isMobile}
                  circled
                  shadowed
                  hoverState
                  buttonLabel="Previous image on Carousel"
                  title={"Left arrow icon"}
                />
              )}
              {!isMobile &&
                filteredCards.length > 1 &&
                position <= maxPositionToShow && (
                  <IconButton
                    onClick={handleNext}
                    className="absolute right-0 bottom-0 top-0 m-auto z-20 transition-opacity duration-200
            flex mr-5 w-10 h-10 md:w-16 md:h-16 md:mr-10"
                    icon="arrow-right"
                    idIcon={"ImageCarousel"}
                    color="white"
                    small={isMobile}
                    circled
                    shadowed
                    hoverState
                    buttonLabel="Next image on Carousel"
                    title={"Right arrow icon"}
                  />
                )}
              <div
                tabIndex={0}
                onFocus={(e) => {
                  setIsEndOfCarousel(true);
                }}
              />
            </CarouselContainer>
          )}
        </PromoPanelContainer>
      )}

      <StyledModal
        isOpen={showModalDisclaimer}
        className="bg-black-faded-light select-none flex w-full"
        data-aos="fade"
      >
        <ModalContent
          isMobile={isMobile}
          className="overflow-auto h-full rounded"
          aria-modal="true"
          role="dialog"
        >
          <div
            tabIndex={0}
            ref={modalRef}
            className="w-full flex flex-col bg-white rounded text-action-blue pt-10 px-5 md:px-10 relative"
            onKeyDown={(e) => {
              if (e.shiftKey && e.key === "Tab") {
                setShowModalDisclaimer(false);
                handleFocus();
              }
            }}
          >
            <button
              className="flex justify-end mt-3 mr-3 z-10 text-mattamy-blue absolute right-0 top-0"
              onClick={(e) => {
                setShowModalDisclaimer(false);
                handleFocus();
              }}
              aria-label={"Close disclaimer text modal"}
            >
              <CloseIcon className="w-8" />
            </button>

            <Copy
              onKeyDown={(e) => {
                if (e.key === "Tab") {
                  modalRef.current.focus();
                }
              }}
              className="text-left pt-1 md:pt-0 pb-24 md:pb-5 lg:pb-10 tracking-tight"
            >
              {promoDisclaimerText}
            </Copy>
          </div>
        </ModalContent>
      </StyledModal>
    </>
  );
};

export default PromosPanel;
